<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="1.500em"
  height="1.500em"
  aria-hidden="true"
  focusable="false"
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.59 9.17L3.5 16.24l4.25 4.25 2.83-2.83L12 19.07l-4.24 4.24-7.07-7.07 9.9-9.9 4.24 4.25L13.4 12 10.6 9.17zm5.65-5.66l-2.83 2.83L12 4.93 16.24.69l7.07 7.07-9.9 9.9-4.24-4.25L10.6 12l2.82 2.83 7.08-7.07-4.25-4.25z"
  /></svg
>
